import React, { useState } from "react";
import { Nav, Navbar, NavItem, NavbarToggler, Collapse, Container } from "reactstrap";
import AnchorLink from "react-anchor-link-smooth-scroll";

// Local-Imports
/* eslint-disable */
import Overview from "./Overview";
import Advantages from "./Advantages";
import Functions from "./Functions";
import ECSFlavours from "./ECSFlavours";
import { propTypes } from "react-bootstrap/esm/Image";
import { Tab } from "react-bootstrap";

const SubNav = ({ overview, advantages, functions, ecsflavours, functionsDetailed, Tables, links, TablesData, CustomTable, onlyMonthly, FilteredTable, filteredData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <div className="bg-subnav">
            <Navbar color="light" light expand="md">
                <Container>
                    <NavbarToggler onClick={toggle} />
                    <Collapse className="subnav-bar" isOpen={isOpen} navbar>
                        <Nav className="mr-auto subnav-innerpage" navbar>
                            <NavItem>
                                <AnchorLink offset="100" href="#overview">
                                    Overview
                                </AnchorLink>
                            </NavItem>
                            {!!advantages ? (
                                <NavItem>
                                    <AnchorLink offset="65" href="#advantages">
                                        Advantages
                                    </AnchorLink>
                                </NavItem>
                            ) : (
                                    ""
                                )}
                            {!!functions ? (
                                <NavItem>
                                    <AnchorLink offset="65" href="#functions">
                                        Functions
                                    </AnchorLink>
                                </NavItem>
                            ) : (
                                    ""
                                )}
                            {!!ecsflavours ? (
                                <NavItem>
                                    <AnchorLink offset="65" href="#ecsflavours">
                                        ECS Flavours
                                    </AnchorLink>
                                </NavItem>
                            ) : (
                                    ""
                                )}
                            {/* {!!TablesData || !!Tables || !!FilteredTable ? (
                                <NavItem>
                                    <AnchorLink offset="80" href="#pricingDetails">
                                        Pricing Details
                                    </AnchorLink>
                                </NavItem>
                            ) : (
                                    ""
                                )} */}
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
            <div id="overview">
                <Overview overview={overview} links={links} />
            </div>
            {!!advantages ? (
                <div id="advantages">
                    <Advantages advantages={advantages} />
                </div>
            ) : (
                    ""
                )}
            {!!functions ? (
                <div id="functions">
                    <Functions functions={functions} functionsDetailed={functionsDetailed} />
                </div>
            ) : (
                    ""
                )}
            {!!ecsflavours ? (
                <div id="ecsflavours">
                    <ECSFlavours ecsflavours={ecsflavours} />
                </div>
            ) : (
                    ""
                )}
            {/* {!!TablesData && (
                <div id="pricingDetails">
                    <CustomTable data={TablesData} onlyMonthly={onlyMonthly} />
                </div>
            )}
            {!!Tables && (
                <div id="pricingDetails">
                    <Tables />
                </div>
            )}
            {!!FilteredTable && (
                <div id="pricingDetails">
                    <FilteredTable data={filteredData} />
                </div>
            )} */}

        </div>
    );
};

export default SubNav;
